import React, {ReactNode, useMemo, useState} from 'react';
import {View} from 'react-native';
import {Text} from '../../components/text';
import {useTabsStyles} from './Tabs.style';

interface TabItem {
  key: string;
  label: ReactNode;
  children: ReactNode;
  isEmpty?: boolean;
  emptyText?: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  defaultKey?: TabItem['key'];
}

export function Tabs({defaultKey, items}: TabsProps) {
  const [selectedKey, setSelectedKey] = useState(defaultKey ?? items[0].key);
  const styles = useTabsStyles();

  const selectedItem = useMemo(() => {
    return items.find((item) => item.key === selectedKey);
  }, [items, selectedKey]);

  return (
    <View style={styles.tabs}>
      <View style={styles.tabButtons}>
        {items.map(({key, label}, index) => (
          <View
            key={key}
            style={[
              styles.tab,
              index === 0 ? styles.firstTab : index === items.length - 1 ? styles.lastTab : undefined,
            ]}>
            <Text
              style={[styles.tabText, selectedKey === key ? styles.activeTab : styles.inactiveTab]}
              onPress={() => setSelectedKey(key)}>
              {label}
            </Text>
          </View>
        ))}
      </View>

      <View key={selectedKey} style={styles.tabContent}>
        {selectedItem?.isEmpty
          ? selectedItem?.emptyText ?? <Text style={styles.emptyText}>Нет данных</Text>
          : selectedItem?.children ?? null}
      </View>
    </View>
  );
}
